/* eslint-disable react-hooks/exhaustive-deps */
import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from "react-i18next";
const DeleteModal = (props) => {
    const { t } = useTranslation();
    const { visible, setVisible, subTitle, onDelete, isDeleteLoading = false, deleteId = "" } = props;
    return (
        <Modal
            className='delete-modal'
            title={t("common.are_you_sure") || "Are you sure?"}
            visible={visible}
            onOk={() => {
                if (deleteId !== "") {
                    onDelete(deleteId)
                } else {
                    onDelete()
                }
            }}
            onCancel={() => setVisible()}
            okText={t('common.delete')}
            okButtonProps={{ disabled: isDeleteLoading, loading: isDeleteLoading }}
            cancelText={t('common.cancel')}

        >
            <p>{subTitle || ""}</p>
        </Modal>
    );
};

export default DeleteModal;